import {
  StickyNote as StickyNoteGraphql,
  UpdateStickyNoteInput,
  UpdateStickyNoteMutationVariables,
} from '@akin-home/amplify';
import { StickyNote } from '@akin-home/sticky-notes';
import {
  serializeStickyNoteForPut,
  updateStickyNoteMutation,
} from '@akin-home/sticky-notes/frontend';
import { useMutation, useQueryClient } from 'react-query';

interface Params {
  options: any;
}

export const useUpdateStickyNoteMutation = (params?: Params) => {
  const queryClient = useQueryClient();

  return useMutation(updateStickyNoteMutation, {
    onSuccess: (data) => {
      const updatedHabitat = data.data.updateStickyNote;

      if (!updatedHabitat) return;

      queryClient.setQueriesData('sticky-notes', (notes: StickyNote[] = []) =>
        notes.map((h) =>
          h.id === updatedHabitat.id ? (updatedHabitat as StickyNote) : h
        )
      );
    },
    ...params?.options,
  });
};

export const useUpdateStickyNote = () => {
  const update = useUpdateStickyNoteMutation();

  return (sticky_note: StickyNote) =>
    update.mutateAsync({ input: serializeStickyNoteForPut(sticky_note) });
};

export const useQuickUpdateStickyNote = () => {
  const queryClient = useQueryClient();

  const update = useUpdateStickyNoteMutation({
    options: {
      /** Don't do anything on Success */
      onSuccess: undefined,

      /** On mutate, set the acknowledged field */
      onMutate: async ({ input }: UpdateStickyNoteMutationVariables) => {
        queryClient.setQueriesData<StickyNoteGraphql[]>(
          'sticky-notes',
          (data = []) => {
            const id = input?.id;
            if (!id) return data;

            return data.map((item) =>
              item.id === id
                ? { ...item, ...(input as StickyNoteGraphql) }
                : item
            );
          }
        );
      },
    },
  });

  return (input: UpdateStickyNoteInput) => update.mutateAsync({ input });
};
